module.exports = __webpack_public_path__ + "static/media/sence1.6180ff9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_inspection/sence1.png
// module id = 555
// module chunks = 0